import React from 'react';
import cx from 'classnames';
import { ModalContentWrapper } from '../../../ui/modals/Modal/ModalContentWrapper/index.js';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../common/GradientWrapper/index.js';
import { Icon } from '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import '../../../common/WithCustomScrollbar/index.js';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../ui/buttons/Button/index.js';
import { CloseButton2 } from '../../../ui/buttons/CloseButton/index.js';
import '../../../ui/buttons/DirectionButton/index.js';
import '../../../ui/buttons/GradientButton/index.js';
import '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import '../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../ui/modals/Modal/Modal.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import styles from './index.module.scss.js';

const MainWrapper = ({
  title,
  onClose,
  showPrevButton,
  navBack,
  children
}) => {
  const { isMobile, isTablet, windowSize } = useWindowSize();
  if (!isMobile && !isTablet) return children;
  return /* @__PURE__ */ React.createElement(
    ModalContentWrapper,
    {
      onClose,
      borderless: isMobile || isTablet,
      style: {
        height: isMobile ? "100svh" : "100%",
        borderRadius: windowSize.width < 767 ? 0 : 14,
        border: 0
      },
      header: /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cx(styles.header, {
            [styles["with-prev"]]: showPrevButton
          })
        },
        windowSize.width < 767 && /* @__PURE__ */ React.createElement("div", { "data-modal-header-line": true }, /* @__PURE__ */ React.createElement("div", null)),
        showPrevButton && /* @__PURE__ */ React.createElement(
          "button",
          {
            type: "button",
            "aria-label": "prev",
            className: styles.prev,
            onClick: navBack
          },
          /* @__PURE__ */ React.createElement(Icon, { iconName: "ArrowLeft2" })
        ),
        /* @__PURE__ */ React.createElement("span", null, title),
        /* @__PURE__ */ React.createElement(
          CloseButton2,
          {
            "aria-label": "close",
            className: styles.close,
            onClick: () => {
              onClose();
            }
          }
        )
      ),
      body: /* @__PURE__ */ React.createElement("div", { className: styles.body }, children)
    }
  );
};
MainWrapper.displayName = "Wallet.MainWrapper";

export { MainWrapper };
//# sourceMappingURL=index.js.map
